module.exports = __webpack_public_path__ + "static/media/twitter.b384ce63.svg";